import React from "react";
import { Flex, Title, ThemeIcon, Text } from "@mantine/core";

export default function PageTitle({ title, subtitle, icon, iconColor, style }) {
  return (
    <div style={{ ...style }}>
      <Title order={3}>{title}</Title>
      {(subtitle || icon) && (
        <Flex align="center">
          {icon && (
            <ThemeIcon
              radius="xl"
              mr="xs"
              size="sm"
              variant="light"
              color={iconColor}
            >
              {icon}
            </ThemeIcon>
          )}
          <Text size="sm">{subtitle}</Text>
        </Flex>
      )}
    </div>
  );
}

PageTitle.defaultProps = {
  style: {
    marginBottom: "1.5em",
  },
};
